import { Injectable } from '@angular/core';
import {CrudService} from './services';
import {Product} from './dto/product';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataListModel} from './models/data-list-model';
import {Upload} from './dto/upload';
import {FeeGroup, LimitGroup, PermsGroup} from './dto/limitGroup';
import {CashbackGroup, CashbackGroupMembership} from './dto/cashbackGroup';

@Injectable({
  providedIn: 'root'
})
export class CashbackGroupsService implements CrudService<CashbackGroup> {

    readonly apiPath = 'cashback-groups/';
    constructor(
      private http: HttpClient,
  ) { }

    getMany(
      pageIndex: number,
      pageSize: number,
      sortField: string,
      sortDirection: string,
      filterString: string,
  ): Observable<DataListModel<CashbackGroup>> {
      const params = new HttpParams()
        .set('page',          pageIndex.toString())
        .set('pageSize',      pageSize.toString())
        .set('filterString',  filterString)
        .set('sortField',     sortField)
        .set('sortDirection', sortDirection);
      return this.http.get(this.apiPath, { params }) as Observable<DataListModel<CashbackGroup>>;
    }

    getAll(): Observable<DataListModel<CashbackGroup>> {
      return this.http.get(this.apiPath) as Observable<DataListModel<CashbackGroup>>;
    }

    get(id: number): Observable<CashbackGroup> {
      return this.http.get(this.apiPath + id) as Observable<CashbackGroup>;
    }

    getForCustomer(customerId: number): Observable<CashbackGroupMembership> {
      return this.http.get(this.apiPath + 'customer/' + customerId) as Observable<CashbackGroupMembership>;
    }
    getForCard(cardId: number): Observable<CashbackGroupMembership> {
      return this.http.get(this.apiPath + 'card/' + cardId) as Observable<CashbackGroupMembership>;
    }

    add(item: CashbackGroup): Observable<CashbackGroup> {
      return this.http.post(this.apiPath, item) as Observable<CashbackGroup>;
    }

    update(id: number, item: CashbackGroup): Observable<CashbackGroup> {
      return this.http.put(this.apiPath, item) as Observable<CashbackGroup>;
    }

    delete(id: any): Observable<Object> {
      return this.deleteMany([id]);
    }

    restore(id: any): Observable<Object> {
      return this.restoreMany([id]);
    }

    deleteMany(idList: any[]): Observable<Object> {
      let httpParams = new HttpParams();

      idList.forEach(id => {
        httpParams = httpParams.append('list', id.toString());
      });

      return this.http.delete(this.apiPath, { params: httpParams });
    }
    restoreMany(idList: any[]): Observable<Object> {
      let httpParams = new HttpParams();
      idList.forEach(id => {
        httpParams = httpParams.append('list', id.toString());
      });
      return this.http.patch(this.apiPath, null, { params: httpParams });
    }

  addCardToCashbackGroup(cardId: number, cashbackGroupId: number) {
    const dto = new CashbackGroupMembership();
    dto.cardId = cardId;
    dto.cashbackGroupId = cashbackGroupId;
    return this.http.post(this.apiPath + 'membership', dto) as Observable<CashbackGroup>;
  }

  removeCardFromCashbackGroup(cardId: number, cashbackGroupId: number) {
    const dto = new CashbackGroupMembership();
    dto.cardId = cardId;
    dto.cashbackGroupId = cashbackGroupId;
    return this.http.delete(this.apiPath + 'membership?cardId=' + cardId + '&cashbackGroupId=' + cashbackGroupId) as Observable<CashbackGroup>;
  }
}
